<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader>
            <CRow>
                <CCol>
                    <h1 class="page__title">{{ integration.name }}</h1>
                    <h6 class="mb-0"></h6>
                </CCol>
            </CRow>
        </CCardHeader>
        <CCardBody class="main-card-body">
            <CContainer fluid class="p-0">
                <CRow>
                    <CCol xl="12" md="12" class="mb-4">
                        <CCard>
                            <CCardHeader>
                                <div class="d-flex">
                                    <ZohoActionsManager
                                        v-if="
                                            plugin.uuid ==
                                            $options.consts.ZOHO_PLUGIN_ID
                                        "
                                        :integration="integration"
                                    />
                                </div>
                            </CCardHeader>
                            <CCardBody>
                                <CContainer :fluid="true">
                                    <CRow>
                                        <CCol md="6">
                                            <h4>Integration information</h4>
                                            <p>
                                                Login:
                                                {{
                                                    integration.temporaryCredentials
                                                        ? "Yes"
                                                        : "No"
                                                }}
                                            </p>
                                        </CCol>
                                        <CCol md="6">
                                            <h4>Plugin information</h4>
                                            <p>Name: {{ plugin.name }}</p>
                                            <p>
                                                Description:
                                                {{ plugin.description }}
                                            </p>
                                            <p>
                                                Require login:
                                                {{
                                                    plugin.temporaryCredentialsRequired
                                                        ? "Yes"
                                                        : "No"
                                                }}
                                            </p>
                                        </CCol>
                                    </CRow>
                                </CContainer>
                            </CCardBody>
                            <CCardFooter>
                                <!-- Button back -->
                                <ButtonBack class="mr-3" />
                            </CCardFooter>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
        </CCardBody>
    </CCard>
</template>

<script>
/** Components */
import FilterDate from "~/components/FilterDate";
import ButtonCreate from "~/components/ButtonCreate";
import TableSettings from "£lement/TableSettings";
import ButtonExport from "~/components/ButtonExport";
import FilterFields from "~/components/FilterFields";
import ButtonBack from "£lement/ButtonBack";
import ZohoActionsManager from "~/pages/app/Integrations/Components/ZohoActionsManager";

/** Mixins */
import pageMixin from "~/mixins/page.js";
import tableMixin from "~/mixins/table.js";

/** Others */
import {
    cilPlus,
    cilSettings,
    cilReload,
    cilPencil,
    cilChart,
    cilTrash,
    cilArrowThickFromRight,
} from "@coreui/icons";
import { mapGetters } from "vuex";
import { ZOHO_PLUGIN_ID } from "~/pages/app/Services/Triggers/Config/Types";

export default {
    name: "ApisPage",
    middleware: ["auth", "page"],
    mixins: [pageMixin, tableMixin],
    components: {
        FilterDate,
        TableSettings,
        ButtonCreate,
        ButtonExport,
        FilterFields,
        ButtonBack,
        ZohoActionsManager,
    },
    consts: {
        ZOHO_PLUGIN_ID,
    },
    icons: {
        cilPlus,
        cilSettings,
        cilPencil,
        cilTrash,
        cilArrowThickFromRight,
        cilReload,
        cilChart,
    },
    data() {
        return {
            integration: {
                uuid: null,
                name: null,
                driverId: null,
            },
            plugin: {
                uuid: null,
                name: null,
                description: null,
                temporaryCredentialsRequired: false,
            },
        };
    },
    computed: {
        ...mapGetters({
            storePlugins: "global/plugins",
        }),
    },
    methods: {
        async updateData() {
            const response = await this.fetcher({
                url: "/connector.api/integrations/" + this.$route.params.uuid,
            });
            this.integration.uuid = response._items.uuid;
            this.integration.name = response._items.name;
            this.integration.driverId = response._items.driver_id;
            this.integration.temporaryCredentials =
                response._items.temporary_credentials;

            const plugin = this.getPlugin(this.integration.driverId);
            this.plugin.uuid = plugin.uuid;
            this.plugin.name = plugin.name;
            this.plugin.description = plugin.description;
            this.plugin.temporaryCredentialsRequired =
                plugin.temporary_credentials_required;
            this.updatePageLoading(false);
        },

        getPlugin(uuid) {
            return this.storePlugins.find((item) => {
                return item.uuid == uuid;
            });
        },
        getPluginName(uuid) {
            let plugin = this.getPlugin(uuid.driver_id);
            if (plugin) {
                return plugin.name;
            } else {
                return "";
            }
        },
        pluginRequireLogin(uuid) {
            let plugin = this.getPlugin(uuid.driver_id);
            if (plugin) {
                return plugin.temporary_credentials_required;
            } else {
                return false;
            }
        },
        getPluginImage(uuid) {
            let plugin = this.getPlugin(uuid);
            if (plugin) {
                return plugin.logo;
            } else {
                return "";
            }
        },

        async loadPlugins() {
            let plugins = await this.fetcher({
                url: "/connector.api/plugins",
            });

            this.$store.dispatch("global/savePlugins", {
                plugins: plugins._items,
            });
        },
    },
    async mounted() {
        await this.loadPlugins();
        await this.updateData();
    },
};
</script>

<style scoped lang="scss">
.plataform__img {
    height: 5em !important;
    width: auto;
}
</style>
